import { cn } from '@/lib/utils';

interface GolfAvatarProps {
  imageUrl?: string;
  username?: string;
  name?: string;
  size?: number;
  canOpen?: boolean;
  className?: string;
}

export function GolfAvatar({
  imageUrl,
  size = 40,
  className = ''
}: GolfAvatarProps) {
  // Calculate the avatar container size in pixels
  const containerSize = `${size}px`;
  const containerClass = `rounded-full ${className}`;

  return (
    <img
      src={imageUrl ? imageUrl : '/assets/images/fallback.jpg'}
      alt="User avatar"
      className={cn('rounded-full border-input/60 bg-secondary object-cover border', containerClass)}
      style={{ width: containerSize, height: containerSize }}
    />

    //   <Avatar className={containerClass} style={{ width: containerSize, height: containerSize }}>
    //   <AvatarImage
    //     src={imageUrl || '/assets/images/fallback.jpg'}
    //     alt={`${name || username || 'User'}'s avatar`}
    //     className="bg-secondary object-cover rounded-full border-input/60 border"
    //     style={{ width: containerSize, height: containerSize }}
    //   />
    //   <AvatarFallback>
    //     <Avvvatars size={size} value={username || name || 'UK'} />
    //   </AvatarFallback>
    // </Avatar>
  );
}
